namespace Solovis.Reports.Parameters {

    export class ValueTypeParameterControl extends Solovis.UI.BaseControl {
        public static hasNewRender = true;

        private initialParameterValue: any;
        private settings: any;

        private _valueTypeSelector: Solovis.UI.InputControl;

        constructor(options) {
            super(options);

            this.initialParameterValue = Solovis.isNotNull(options.initialValue) ? options.initialValue : null;
            this.settings = options.settings ? options.settings : {};
        }

        public static getLabel(value): string | undefined {
            if (value == null) {
                return undefined;
            }
            return Solovis.Site.ValueTypes.getValueTypeOptions(value).find(o => o.value === value)?.text;
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {
            const self = this;
            const target = self.container[0];

            let activeValueTypeId = self.initialParameterValue;
            let valueTypeOptions = Solovis.Site.ValueTypes.getValueTypeOptions(activeValueTypeId);

            await Solovis.UX.Utils.placeComponent("Select", target, {
                defaultValue: (valueTypeOptions as any).find(option => option.value === activeValueTypeId),
                isSearchable: false,
                isClearable: self.settings.allowNull === true,
                options: valueTypeOptions,
                getOptionLabel: (option) => option.text,
                getOptionValue: (option) => option.value,
                onChange: (item) => {
                    const value = item ? item.value : null;
                    self.setParameterValue(value);
                    self.notifyParameterValueChanged();
                },
            });
        }

        private doRenderClassic() {
            let self = this;

            this.container.addClass("report-param-valuetype");

            let activeValueTypeId = this.initialParameterValue;

            let valueTypeOptions = Solovis.Site.ValueTypes.getValueTypeOptions(activeValueTypeId);

            if (this.settings.allowNull === true) {
                valueTypeOptions.splice(0, 0, { text: "", value: null });
            }

            this._valueTypeSelector = new Solovis.UI.InputControl({
                container: this.container,
                type: "select",
                data: valueTypeOptions,
                value: activeValueTypeId,
                change: function () {
                    self.notifyParameterValueChanged();
                }
            });
        }

        public setParameterValue(newValue) {
            if (this._valueTypeSelector) {
                this._valueTypeSelector.value(newValue);
            }
            else {
                this.initialParameterValue = newValue;
            }
        }

        public getParameterValue() {
            if (this._valueTypeSelector) {
                let value = this._valueTypeSelector.value();
                if ($.isNumeric(value)) {
                    value = parseInt(value);
                }
                else {
                    value = null;
                }
                return value;
            }
            else {
                return this.initialParameterValue;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }

}
